import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function SEOContentSection() {
  return <section className="py-16 bg-white border-t border-gray-200" data-id="element-529" data-mp="tvo7ogvfucwf">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-530" data-mp="tttlz0ccegra">
        <div className="prose prose-lg prose-navy max-w-none" data-id="element-531" data-mp="yo7jp9eh8zz4">
          <h2 className="text-3xl font-bold text-navy mb-6 text-center" data-id="element-532" data-mp="13mivhpoc1kjz">
            Why Choose an Online Degree?
          </h2>

          <p className="text-gray-600 mb-8 text-center" data-id="element-533" data-mp="5zit44b1sd1m">
            Online education has transformed how adults achieve their academic
            and career goals. With flexible scheduling, lower overall costs, and
            the same rigorous curriculum as on-campus programs, earning your
            degree online is a smart investment in your future.
          </p>

          <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-534" data-mp="1rc3hkhfs8xxh">
            <div className="bg-light p-6 rounded-xl border border-gray-100" data-id="element-535" data-mp="1rdoa61ije6sp">
              <h3 className="text-xl font-bold text-navy mb-3 flex items-center" data-id="element-536" data-mp="1w93muq4t5wnj">
                <CheckCircleIcon className="w-5 h-5 text-green-500 mr-2" data-id="element-537" data-mp="wybzd8c7gq94" />
                Flexibility & Convenience
              </h3>
              <p className="text-sm text-gray-600" data-id="element-538" data-mp="ryfs9087oipc">
                Study when and where it works for you. Online programs are
                designed for working professionals, allowing you to balance
                education with career and family responsibilities.
              </p>
            </div>
            <div className="bg-light p-6 rounded-xl border border-gray-100" data-id="element-539" data-mp="e2lwliwg7pu6">
              <h3 className="text-xl font-bold text-navy mb-3 flex items-center" data-id="element-540" data-mp="98q0yn3nqf26">
                <CheckCircleIcon className="w-5 h-5 text-green-500 mr-2" data-id="element-541" data-mp="4braqfn46s99" />
                Career Advancement
              </h3>
              <p className="text-sm text-gray-600" data-id="element-542" data-mp="79rchko2gz0">
                Employers increasingly value online degrees from accredited
                institutions. Gain the skills needed for promotions or career
                changes without leaving your current job.
              </p>
            </div>
          </div>

          <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-543" data-mp="3hs1tevvbtw41">
            How Our Matching Service Works
          </h2>
          <p className="text-gray-600 mb-6" data-id="element-544" data-mp="32varaeu9q6aq">
            Finding the right school can be overwhelming. We simplify the
            process by connecting you with accredited institutions that match
            your specific needs:
          </p>

          <ol className="space-y-4 mb-8 text-gray-600" data-id="element-545" data-mp="3vjyh8npypjum">
            <li className="flex items-start" data-id="element-546" data-mp="4dong6n70qpv">
              <span className="flex items-center justify-center w-8 h-8 rounded-full bg-navy text-white font-bold text-sm mr-4 flex-shrink-0" data-id="element-547" data-mp="4cdkua5hhp0c">
                1
              </span>
              <div data-id="element-548" data-mp="3qrf3nqr9yopt">
                <strong className="text-navy block" data-id="element-549" data-mp="3qqx2cfpr9kb1">
                  Tell us about your goals
                </strong>
                Complete our short form to share your area of interest, current
                education level, and contact information.
              </div>
            </li>
            <li className="flex items-start" data-id="element-550" data-mp="27s7gxhgk5htq">
              <span className="flex items-center justify-center w-8 h-8 rounded-full bg-navy text-white font-bold text-sm mr-4 flex-shrink-0" data-id="element-551" data-mp="22vh18v8o0o8u">
                2
              </span>
              <div data-id="element-552" data-mp="2cks6u7wcfarz">
                <strong className="text-navy block" data-id="element-553" data-mp="2ck8q2uifisfj">
                  Get matched instantly
                </strong>
                Our system filters through hundreds of accredited programs to
                find the ones that align with your criteria.
              </div>
            </li>
            <li className="flex items-start" data-id="element-554" data-mp="1xvm78itlfijk">
              <span className="flex items-center justify-center w-8 h-8 rounded-full bg-navy text-white font-bold text-sm mr-4 flex-shrink-0" data-id="element-555" data-mp="1xxfi6ab8ooxd">
                3
              </span>
              <div data-id="element-556" data-mp="399zqtbhbdbts">
                <strong className="text-navy block" data-id="element-557" data-mp="3997xy8f3ps77">Compare and enroll</strong>
                Receive information directly from the schools, compare your
                options, and take the next step toward your degree.
              </div>
            </li>
          </ol>
        </div>
      </div>
    </section>;
}